// @ts-nocheck

import React, { useRef, useCallback, useEffect } from 'react';
import type { ElementRef } from 'react';
import styled from 'styled-components';

import exclusaoLogoUrl from '../../assets/img/mobile/exclusao.png';
import jogueComModeracaoLogoUrl from '../../assets/img/mobile/jogue-com-moderacao.png';
import jugadoresJuegoResponsableLogoUrl from '../../assets/img/mobile/jugadores-juego-responsable.png';
import sicadLogoUrl from '../../assets/img/mobile/sicad.png';
import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';

const Wrapper = styled.div`
  font-size: 0.65em;
  font-family: 'BettingArchivoNarrow';
  padding: 1em;
  line-height: normal;
  color: ${theme.Legal.color};
`;

const Logos = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-grow: 1;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1em;
`;

const JogueComModeracaoLogo = styled.div`
  background-image: url(${jogueComModeracaoLogoUrl});
  background-size: 100%;
  background-repeat: no-repeat;
  width: 20em;
  max-width: 213.65px;
  height: 3.75em;
  max-height: 40px;
`;

const ExclusaoLogo = styled.div`
  background-image: url(${exclusaoLogoUrl});
  background-size: 100%;
  background-repeat: no-repeat;
  height: 46px;
  width: 40px;
`;

const SicadLogo = styled.div`
  background-image: url(${sicadLogoUrl});
  background-repeat: no-repeat;
  background-size: contain;
  width: 5.21em;
  max-width: 83.43px;
  height: 2.5em;
  max-height: 40px;
`;

const JugadoresJuegoResponsableLogo = styled.div`
  background: url(${jugadoresJuegoResponsableLogoUrl}) no-repeat;
  height: 40px;
  width: 40px;
`;

const LegalPt = () => {
  const ref = useRef<ElementRef<'div'> | null>(null);

  const onTick = useCallback(() => {
    const div = ref.current;
    if (div) {
      div.innerText = new Date().toTimeString();
    }
  }, []);

  useEffect(() => {
    let interval = setInterval(onTick, 500);
    onTick();

    return () => {
      clearInterval(interval);
      interval = null;
    };
  }, [onTick]);

  return (
    <Wrapper>
      <Logos>
        <Row>
          <LogoWrapper>
            <JogueComModeracaoLogo />
          </LogoWrapper>
          <LogoWrapper>
            <JugadoresJuegoResponsableLogo />
          </LogoWrapper>
        </Row>
        <Row>
          <LogoWrapper>
            <ExclusaoLogo />
          </LogoWrapper>
          <LogoWrapper>
            <SicadLogo />
          </LogoWrapper>
        </Row>
      </Logos>
      <p>{__('!desc:SrijLicence')}</p>
      {/* Clock */}
      <div ref={ref} />
    </Wrapper>
  );
};

export default React.memo<unknown>(LegalPt);
